<template>
  <div class="the-nav-menu">
    <el-menu
      :default-active="defaultActive"
      :unique-opened="true"
      class="el-menu-class"
      @select="menuSelectHandler"
    >
      <template v-for="({ meta, children, name }, index) of navMenuConfig">
        <template v-if="meta.hasRoute()">
          <el-menu-item
            v-if="!children"
            :key="index"
            :index="name"
            :class="[defaultActive === name ? 'el-menu-item-actived' : '']"
          >
            <img :src="`/static/img/common/${meta.icon}.png`" class="img-icon">
            <span slot="title">{{ meta.name }}</span>
          </el-menu-item>
          <el-submenu v-else :key="index" :index="`${index}`">
            <template slot="title">
              <img :src="`/static/img/common/${meta.icon}.png`" class="img-icon">
              <span>{{ meta.name }}</span>
            </template>
            <template v-for="({ meta: Meta, name: name2 }, i) of children">
              <el-menu-item
                v-if="Meta.hasRoute()"
                :key="i"
                :index="name2"
                :class="[defaultActive === name2 ? 'el-menu-item-actived' : '']"
              >
                {{ Meta.name }}
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
      </template>
    </el-menu>
    <i class="bottom-line" />
  </div>
</template>

<script>
import { navMenuConfig } from '@/router/routes'

/**
 * @description                  判断当前用户是否有权限访问某些路由
 * @param {Array} navMenuConfig  所有的路由信息
 * @return {Array}               可访问的路由信息
 */
function getNavMenu (navMenuConfig = [], level = 1) {
  return navMenuConfig.reduce((prev, { meta, ...rest }) => {
    const show = level === 1 ? meta.nav : true

    // 是否有权限显示
    if (show && meta.hasRoute()) {
      // 如果没有 children, 将该项返回
      if (!Array.isArray(rest.children)) {
        return [...prev, { meta, ...rest }]
      }

      // 如果有子集则需要递归处理
      const children = getNavMenu(rest.children, level + 1)

      // 如果处理后的子集不为空数组，则需要将该项返回
      if (children.length) {
        return [
          ...prev,
          {
            ...rest,
            meta,
            children,
          },
        ]
      }
    }

    return prev
  }, [])
}

export default {
  name: 'TheNavMenu',
  data () {
    return {
      navMenuConfig: getNavMenu(navMenuConfig),
      defaultActive: 'home',
    }
  },
  created () {
    this.setRefreshSelectedStatu()
  },
  methods: {
    /**
     * @description                   menu 组件 select 事件
     * @param  {String}               index 值
     * @return {undefied}             无返回值
     */
    menuSelectHandler (name) {
      this.defaultActive = name

      this.$router.push({ name })
    },
    /**
     * @description                   页面刷新时设置选中状态
     * @return {undefied}             无返回值
     */
    setRefreshSelectedStatu () {
      const matched = this.$route.matched.slice(1)
      const firstName = matched[0].name

      this.setDefaultActive(this.navMenuConfig, firstName)
    },
    /**
     * @description                   设置 defaultActive 值
     * @return {Boolean}              是否结束查找
     */
    setDefaultActive (arr, firstName) {
      return arr.some(({ name, children }) => {
        let is = name === firstName

        if (is) {
          this.defaultActive = name

          return is
        }

        if (children) {
          is = this.setDefaultActive(children, firstName)
        }

        return is
      })
    },
  },
}
</script>

<style lang="less" scoped>
.the-nav-menu {
  height: 790px;
  width: 190px;
  background-color: #fff;
  position: relative;
  overflow: hidden;

  /deep/ .el-menu {
    border: none;

    .el-menu-item {
      min-width: 190px;
      color: #4078dd;
      border-left: 4px solid transparent;
    }

    .el-menu-item.is-active {
      background-color: #bed2f7;
      font-weight: bold;
    }

    .el-menu-item-actived,
    .el-menu-item:hover {
      color: #5294d6 !important;
      background-color: #d1e5fb !important;
      padding-left: 60px;
      border-left: 4px solid #5d98e9 !important;
    }

    .el-submenu__title {
      font-size: 16px;
      color: #4078dd;
      font-weight: bold;
      border-left: 4px solid transparent;
    }

    .el-menu--inline {
      font-size: 14px;

      .el-menu-item {
        padding-left: 62px !important;
        border-left: 4px solid transparent;
      }
    }

    .el-submenu__icon-arrow {
      font-size: 16px !important;
    }

    .img-icon {
      margin-right: 13px;
      width: 24px;
      height: 21px;
    }
  }

  .el-menu-class {
    // margin-top: 6px;

    > .el-menu-item {
      font-size: 16px;
    }
  }

  .bottom-line {
    position: absolute;
    bottom: 0;
    height: 4px;
    width: 100%;
    background-color: #2b3e9c;
  }
}
</style>
